import { createContext, useContext, useState } from 'react'

const NavbarContext = createContext()

export const NavbarProvider = ({ children }) => {
  const [showNavbar, setShowNavbar] = useState(true)

  const show = () => {
    setShowNavbar(true)
  }

  const hide = () => {
    setShowNavbar(false)
  }

  return (
    <NavbarContext.Provider value={{ show, hide, showNavbar }}>
      {children}
    </NavbarContext.Provider>
  )
}

export const useNavbar = () => {
  return useContext(NavbarContext)
}
